import BaseNodeModel from "../BaseNodeModel";

export default class ReportBillingNodeModel extends BaseNodeModel {
    /**
     * Report node model
     * @module ReportBillingNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = "Report Billing Tag";
        this.props.colorClass = "brown";
        this.props.iconClass = "pause-circle";
        this.props.configView = [
            {type: "Input", key: "tagData", label: this.getPropLabel("metric_name"), hint: this.getPropLabel("metric_name")},
            {type: "Dropdown", key: "tag", label: this.getPropLabel("tag"), optionName: this.getPropLabel("select_tag"),
            options: [
                {name: "START", value: "START"}, {name: "END", value: "END"}
            ]}
        ];
        this.DEFAULT_COLOR_CLASS = "brown";
        this.applyProps(props);
    }

    getConfigViews(){
        return [
            ...this.getConfigViewNameField(),
            ...this.props.configView,
            ...[
                {type: "hr"},
                {type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ];
    }

}
